/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */


export const dismissalCheckinStyle = {
  formPaper: {
    padding: { xs: "20px 40px", md: "20px" },
  },
  buttonContainer: {
    marginRight: "auto",
    marginLeft: "auto",
  },
  heading: {
    textAlign: "center",
  },
  button: {
    marginTop: "25px",
  },
  classification: {
    width: "100%",
  },
  email: {
    width: "100%",
  },
  default: {
  },
  grey: {
    backgroundColor: "background.contrast",
  },
};
